import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '@app/core/helperclasses/basecomponent';
import { UntilDestroy } from '@ngneat/until-destroy';

export interface ProgressConfig {
  isStacked: boolean;
  height: 2 | 4 | 8 | 12 | 16;
  segmentDefinitions: ProgressConfigSegmentDefinition[];
}

export interface ProgressConfigSegmentDefinition {
  value: number;
  colorType: 'primary' | 'secondary' | 'tertiary' | 'error' | 'success';
}

@UntilDestroy()
@Component({
  selector: 'progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.style.scss'],
  host: {
    class: 'progress-bar-sc',
  },
})
export class ProgressBarComponent
  extends BaseComponent
  implements OnInit, OnChanges
{
  @Input() config!: ProgressConfig | undefined;
  @Input() value: number = 0;
  public isComplete: boolean = false;
  public isElevated: boolean = false;

  constructor() {
    super();
  }

  ngOnInit() {
    if (!this.config) {
      this.config = {
        isStacked: false,
        height: 2,
        segmentDefinitions: [
          {
            value: this.value,
            colorType: 'primary',
          },
        ],
      };
    }
    this.checkCompleteState();
  }

  ngOnChanges(event: SimpleChanges) {
    if (event['config']) {
      this.config = event['config'].currentValue;
      this.checkCompleteState();
    }
    if (event['value']) {
      this.value = event['value'].currentValue;
      this.config = undefined;
      setTimeout(() => {
        this.config = {
          isStacked: false,
          height: 2,
          segmentDefinitions: [
            {
              value: this.value,
              colorType: 'primary',
            },
          ],
        };
      });

      this.checkCompleteState();
    }
  }

  checkCompleteState() {
    if (this.config) {
      this.isComplete =
        this.config.segmentDefinitions.findIndex(
          (segmentDefinition) => segmentDefinition.value == 100,
        ) != -1;
    } else {
      this.isComplete = this.value == 100;
    }
  }
}
